/**
 * The kit gallery at /__kit (every kit part Keystone added, in each state), in dev and mock builds
 * only. The fidelity fixture at /__replica is a page of its own (frontend/__replica.html). The test is
 * written out here, not read from demo.ts, so a production build drops the import with it.
 */
import type { RouteObject } from "react-router-dom";

export const galleryRoutes: RouteObject[] =
  import.meta.env.DEV || import.meta.env.VITE_USE_MOCKS === "1" || import.meta.env.VITE_USE_MOCKS === "true"
    ? [{ path: "__kit", lazy: async () => ({ Component: (await import("../gallery")).default }) }]
    : [];

/** True on the gallery, which calls no API: its first paint does not wait for the mock worker. */
export function onGalleryPage(): boolean {
  return galleryRoutes.length > 0 && window.location.pathname.replace(/\/$/, "") === "/__kit";
}
